import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { DebtAnalysisWidgetConfiguration } from '../models/debt-analysis-widget-configuration.model';
import { DebtAnalysisAdminWidgetConfiguration } from '../models/debt-analysis-admin-widget-configuration.model';

@Injectable()
export class DebtAnalysisWidgetConfigurationHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService
  ) { }

  getConfigs(): Observable<Array<DebtAnalysisWidgetConfiguration>> {
    const url = this
      .urlBuilder
      .getUrl('debtanalysis/configs');

    return this
      .http
      .get<Array<DebtAnalysisWidgetConfiguration>>(url);

  }

  saveAdminConfiguration(config: DebtAnalysisAdminWidgetConfiguration): Observable<boolean> {
    const url = this
      .urlBuilder
      .getUrl('debtanalysis/config');

    return this.http
      .post<DebtAnalysisAdminWidgetConfiguration>(url, config).pipe(
        map(res => true)
      );
  }

  getConfig(debtAnalysisWidgetConfigurationId: number): Observable<DebtAnalysisWidgetConfiguration> {
    const url = this
      .urlBuilder
      .getUrl('debtanalysis/config');

    const httpParams = new HttpParams()
      .append('widgetConfigurationId', debtAnalysisWidgetConfigurationId.toString());

    return this
      .http
      .get<DebtAnalysisWidgetConfiguration>(url, { params: httpParams });
  }


  createCopyOfConfiguration(config: DebtAnalysisAdminWidgetConfiguration) {
    const url = this.urlBuilder.getUrl('debtanalysis/config/copy');
    return this
      .http
      .post(url, config);
  }

}
